<app-generic-container>
  <!-- Usamos el panel genérico -->
  <app-generic-panel [title]="'Conexión A3Doc Cloud'" [description]="" [awesomeIcon]="'microchip'">
    <ng-container *ngIf="model">
      <div class="row">
        <div class="col-6 mr-auto">
          <div class="col-12">
            <div class="row">
              <mat-form-field class="col-3">
                <input matInput type="text" [(ngModel)]="model.tenant" name="teanant" placeholder="Cliente" />
              </mat-form-field>
              <mat-form-field class="col-3">
                <input matInput type="text" [(ngModel)]="model.user" name="name" placeholder="Nombre" />
              </mat-form-field>
              <mat-form-field class="col-6">
                <input matInput [type]="typePassword" [(ngModel)]="model.password" name="password"
                  placeholder="Contraseña" (click)="toggleTypePassword()" />
              </mat-form-field>
            </div>
          </div>

          <div class="col-12">
            <div class="row">
              <mat-form-field class="col-12">
                <input matInput [type]="typeApiKey" [(ngModel)]="model.apiKey" name="apiKey" placeholder="Api Key"
                  (click)="toggleTypeApiKey()" />
              </mat-form-field>
            </div>
          </div>

        </div>
      </div>

      <!-- Botonera -->
      <div class="row">
        <div class="col-6 mr-auto">
          <div class="form-group form-button">
            <button class="btn btn-primary float-left" (click)="testConnection()">
              <ng-container *ngIf="buttonIcon">
                <fa-icon [icon]="buttonIcon" size="1x"></fa-icon>
              </ng-container>
              {{ buttonText }}
            </button>

            <button class="btn btn-fill btn-success float-right" (click)="save()">Guardar</button>
            <a class="btn btn-fill btn-danger float-right" routerLink="../">Volver</a>
          </div>
        </div>
      </div>
    </ng-container>
  </app-generic-panel>


</app-generic-container>